import { TemplateCategory } from "./types";

export const previdenciariasCategory: TemplateCategory = {
  id: 'previdenciarias',
  name: 'Previdenciárias',
  emoji: '🧾',
  description: 'Documentos relacionados à previdência social',
  subcategories: [
    {
      id: 'requerimentos-previdenciarios',
      name: 'Requerimentos de Benefícios',
      emoji: '📋',
      templates: [
        {
          id: 'requerimento-aposentadoria',
          name: 'Requerimento de aposentadoria',
          type: 'Aposentadoria',
          description: 'Solicitação de benefício de aposentadoria',
          icon: 'FileText',
          content: `REQUERIMENTO DE APOSENTADORIA

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer a concessão do benefício de aposentadoria [TIPO DE APOSENTADORIA].

DADOS PESSOAIS:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- RG: [RG]
- Data de Nascimento: [DATA]
- NIT/PIS: [NÚMERO]

FUNDAMENTAÇÃO: [DESCRIÇÃO DOS REQUISITOS CUMPRIDOS]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-pensao',
          name: 'Requerimento de pensão por morte',
          type: 'Pensão',
          description: 'Solicitação de pensão por morte',
          icon: 'FileText',
          content: `REQUERIMENTO DE PENSÃO POR MORTE

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], na qualidade de [GRAU DE PARENTESCO] de [NOME DO SEGURADO FALECIDO], vem requerer a concessão do benefício de pensão por morte.

DADOS DO SEGURADO FALECIDO:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- Data de Nascimento: [DATA]
- Data do Óbito: [DATA]
- NIT/PIS: [NÚMERO]

DADOS DO REQUERENTE:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- RG: [RG]
- Data de Nascimento: [DATA]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-auxilio-doenca',
          name: 'Requerimento de auxílio-doença',
          type: 'Auxílio',
          description: 'Solicitação de auxílio por incapacidade temporária',
          icon: 'FileText',
          content: `REQUERIMENTO DE AUXÍLIO-DOENÇA

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer a concessão do benefício de auxílio-doença.

DADOS PESSOAIS:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- RG: [RG]
- Data de Nascimento: [DATA]
- NIT/PIS: [NÚMERO]

MOTIVO DA INCAPACIDADE:
[DESCRIÇÃO DA DOENÇA/ACIDENTE]

PERÍODO DE AFASTAMENTO:
Início: [DATA]
Previsão de retorno: [DATA]

DOCUMENTOS ANEXOS:
- Atestado médico
- Exames complementares
- [OUTROS DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-bpc',
          name: 'Requerimento de BPC/LOAS',
          type: 'BPC',
          description: 'Benefício de Prestação Continuada',
          icon: 'FileText',
          content: `REQUERIMENTO DE BENEFÍCIO DE PRESTAÇÃO CONTINUADA - BPC/LOAS

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer a concessão do Benefício de Prestação Continuada - BPC, previsto na Lei nº 8.742/93.

DADOS PESSOAIS:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- RG: [RG]
- Data de Nascimento: [DATA]

SITUAÇÃO:
( ) Pessoa com deficiência
( ) Pessoa idosa (65 anos ou mais)

RENDA FAMILIAR:
Renda per capita: R$ [VALOR]
Composição familiar: [NÚMERO DE PESSOAS]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-salario-maternidade',
          name: 'Requerimento de salário-maternidade',
          type: 'Salário-Maternidade',
          description: 'Solicitação de licença maternidade',
          icon: 'FileText',
          content: `REQUERIMENTO DE SALÁRIO-MATERNIDADE

Ao INSS - Instituto Nacional do Seguro Social

[NOME DA REQUERENTE], [QUALIFICAÇÃO], vem requerer a concessão do benefício de salário-maternidade.

DADOS PESSOAIS:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- RG: [RG]
- Data de Nascimento: [DATA]
- NIT/PIS: [NÚMERO]

DADOS DO NASCIMENTO/ADOÇÃO:
- Data do parto/adoção: [DATA]
- Nome do(a) filho(a): [NOME]

PERÍODO DO BENEFÍCIO:
Início: [DATA DE INÍCIO]
Término: [DATA DE TÉRMINO]

DOCUMENTOS ANEXOS:
- Certidão de nascimento
- Atestado médico
- [OUTROS DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DA REQUERENTE]`
        },
        {
          id: 'requerimento-auxilio-acidente',
          name: 'Requerimento de auxílio-acidente',
          type: 'Auxílio-Acidente',
          description: 'Solicitação por sequela de acidente',
          icon: 'AlertTriangle',
          content: `REQUERIMENTO DE AUXÍLIO-ACIDENTE

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer o auxílio-acidente.

DADOS DO ACIDENTE:
Data: [DATA DO ACIDENTE]
Local: [LOCAL DO ACIDENTE]
Natureza: [ACIDENTE DE TRABALHO/TRAJETO]

SEQUELAS:
[DESCRIÇÃO DAS SEQUELAS PERMANENTES]

GRAU DE INCAPACIDADE: [PERCENTUAL]%

DOCUMENTOS ANEXOS:
- CAT (Comunicação de Acidente)
- Relatórios médicos
- Exames comprobatórios

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-auxilio-reclusao',
          name: 'Requerimento de auxílio-reclusão',
          type: 'Auxílio-Reclusão',
          description: 'Benefício para dependentes de segurado recluso',
          icon: 'Users',
          content: `REQUERIMENTO DE AUXÍLIO-RECLUSÃO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], na qualidade de dependente de [NOME DO SEGURADO RECLUSO], vem requerer auxílio-reclusão.

DADOS DO SEGURADO RECLUSO:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- Data de prisão: [DATA]
- Local de cumprimento: [ESTABELECIMENTO PRISIONAL]

RENDA DO SEGURADO: R$ [VALOR] (último salário)

DEPENDENTES:
[LISTA DOS DEPENDENTES]

DOCUMENTOS ANEXOS:
- Certidão de prisão
- Declaração de não recebimento de benefício
- Comprovantes de dependência

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-aposentadoria-especial',
          name: 'Requerimento de aposentadoria especial',
          type: 'Aposentadoria Especial',
          description: 'Aposentadoria por atividade insalubre',
          icon: 'Shield',
          content: `REQUERIMENTO DE APOSENTADORIA ESPECIAL

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer aposentadoria especial por exercer atividade insalubre/perigosa.

ATIVIDADE ESPECIAL:
[DESCRIÇÃO DA ATIVIDADE]

PERÍODO DE EXPOSIÇÃO:
De [DATA] a [DATA] = [ANOS] anos

AGENTES NOCIVOS:
[RELAÇÃO DOS AGENTES]

TEMPO TOTAL DE CONTRIBUIÇÃO: [ANOS] anos

DOCUMENTOS ANEXOS:
- PPP (Perfil Profissiográfico)
- LTCAT (Laudo Técnico)
- Formulários SB-40/DSS-8030

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        }
      ]
    },
    {
      id: 'recursos-previdenciarios',
      name: 'Recursos Administrativos',
      emoji: '📑',
      templates: [
        {
          id: 'recurso-ordinario',
          name: 'Recurso ordinário ao INSS',
          type: 'Recurso',
          description: 'Recurso contra decisão do INSS',
          icon: 'Scale',
          content: `RECURSO ORDINÁRIO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO RECORRENTE], [QUALIFICAÇÃO], vem interpor RECURSO ORDINÁRIO contra a decisão proferida no processo nº [NÚMERO], pelos seguintes fundamentos:

I - DOS FATOS
[RELATO DOS FATOS]

II - DO DIREITO
[FUNDAMENTAÇÃO JURÍDICA]

III - DOS PEDIDOS
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede reconsideração.

[LOCAL], [DATA]

_________________________________
[NOME DO RECORRENTE]`
        },
        {
          id: 'recurso-especial-inss',
          name: 'Recurso especial ao CRPS',
          type: 'Recurso',
          description: 'Recurso ao Conselho de Recursos da Previdência Social',
          icon: 'Scale',
          content: `RECURSO ESPECIAL AO CRPS

Ao Conselho de Recursos da Previdência Social - CRPS

[NOME DO RECORRENTE], [QUALIFICAÇÃO], vem interpor RECURSO ESPECIAL contra a decisão proferida em recurso ordinário no processo nº [NÚMERO]:

I - DA DECISÃO RECORRIDA
[RESUMO DA DECISÃO]

II - DOS FUNDAMENTOS RECURSAIS
[ARGUMENTAÇÃO JURÍDICA]

III - DOS PEDIDOS
[PEDIDOS ESPECÍFICOS]

Nestes termos, pede provimento.

[LOCAL], [DATA]

_________________________________
[NOME DO RECORRENTE]`
        },
        {
          id: 'pedido-revisao',
          name: 'Pedido de revisão de benefício',
          type: 'Revisão',
          description: 'Solicitação de revisão de benefício previdenciário',
          icon: 'FileText',
          content: `PEDIDO DE REVISÃO DE BENEFÍCIO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], beneficiário do [TIPO DE BENEFÍCIO] nº [NÚMERO], vem solicitar a revisão do referido benefício.

DADOS DO BENEFÍCIO:
- Número do benefício: [NB]
- Data de início: [DATA]
- Valor atual: R$ [VALOR]

FUNDAMENTAÇÃO:
[MOTIVO DA REVISÃO]

NOVO VALOR PLEITEADO: R$ [VALOR]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'pedido-reconsideracao',
          name: 'Pedido de reconsideração',
          type: 'Reconsideração',
          description: 'Solicitação de nova análise da decisão',
          icon: 'RotateCcw',
          content: `PEDIDO DE RECONSIDERAÇÃO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem solicitar RECONSIDERAÇÃO da decisão proferida no processo nº [NÚMERO]:

DECISÃO QUESTIONADA:
[RESUMO DA DECISÃO]

NOVOS ARGUMENTOS:
[FUNDAMENTAÇÃO ADICIONAL]

NOVOS DOCUMENTOS:
[LISTA DE DOCUMENTOS JUNTADOS]

PEDIDO:
Reconsideração da decisão para [NOVO PEDIDO]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'embargo-declaracao-inss',
          name: 'Embargos de declaração',
          type: 'Embargos',
          description: 'Correção de erro material ou omissão',
          icon: 'AlertCircle',
          content: `EMBARGOS DE DECLARAÇÃO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO EMBARGANTE], [QUALIFICAÇÃO], vem opor EMBARGOS DE DECLARAÇÃO contra a decisão de [DATA]:

VÍCIOS APONTADOS:
( ) Obscuridade
( ) Contradição
( ) Omissão
( ) Erro material

FUNDAMENTAÇÃO:
[DESCRIÇÃO DOS VÍCIOS]

PEDIDO:
Saneamento dos vícios apontados

Nestes termos, pede acolhimento.

[LOCAL], [DATA]

_________________________________
[NOME DO EMBARGANTE]`
        }
      ]
    },
    {
      id: 'beneficios-especiais',
      name: 'Benefícios Especiais',
      emoji: '🎯',
      templates: [
        {
          id: 'requerimento-aposentadoria-rural',
          name: 'Aposentadoria rural por idade',
          type: 'Aposentadoria Rural',
          description: 'Aposentadoria para trabalhador rural',
          icon: 'Tractor',
          content: `REQUERIMENTO DE APOSENTADORIA RURAL POR IDADE

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], na condição de trabalhador rural, vem requerer aposentadoria por idade.

ATIVIDADE RURAL:
Período: [DATA INÍCIO] a [DATA FIM]
Local: [MUNICÍPIO/PROPRIEDADE]
Função: [ATIVIDADE EXERCIDA]

IDADE: [IDADE] anos

TEMPO DE ATIVIDADE RURAL: [ANOS] anos

DOCUMENTOS COMPROBATÓRIOS:
- Declaração de sindicato rural
- Contratos de parceria/meação
- Notas fiscais de venda
- Cadastro no INCRA

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-aposentadoria-deficiente',
          name: 'Aposentadoria da pessoa com deficiência',
          type: 'Aposentadoria PCD',
          description: 'Aposentadoria para pessoa com deficiência',
          icon: 'Accessibility',
          content: `REQUERIMENTO DE APOSENTADORIA DA PESSOA COM DEFICIÊNCIA

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], pessoa com deficiência, vem requerer aposentadoria.

TIPO DE DEFICIÊNCIA:
[DESCRIÇÃO DA DEFICIÊNCIA]

GRAU: 
( ) Leve
( ) Moderada  
( ) Grave

TEMPO DE CONTRIBUIÇÃO: [ANOS] anos

COMPROVAÇÃO MÉDICA:
[DOCUMENTOS MÉDICOS]

LAUDOS ANEXOS:
- Avaliação médica e social
- Exames complementares
- Relatórios especializados

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-aposentadoria-professor',
          name: 'Aposentadoria de professor',
          type: 'Aposentadoria Professor',
          description: 'Aposentadoria especial do magistério',
          icon: 'GraduationCap',
          content: `REQUERIMENTO DE APOSENTADORIA DE PROFESSOR

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], professor(a), vem requerer aposentadoria especial do magistério.

ATIVIDADE DOCENTE:
Nível de ensino: [INFANTIL/FUNDAMENTAL/MÉDIO]
Período: [DATA INÍCIO] a [DATA FIM]
Tempo de efetivo exercício: [ANOS] anos

INSTITUIÇÕES:
[RELAÇÃO DAS ESCOLAS]

DOCUMENTOS ANEXOS:
- Certidões de tempo de serviço
- Declarações de função
- Histórico funcional

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-amparo-social-idoso',
          name: 'Amparo social ao idoso',
          type: 'Amparo Social',
          description: 'BPC para pessoa idosa carente',
          icon: 'Heart',
          content: `REQUERIMENTO DE AMPARO SOCIAL AO IDOSO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], pessoa idosa em situação de vulnerabilidade, vem requerer amparo social.

IDADE: [IDADE] anos (65 anos ou mais)

SITUAÇÃO SOCIOECONÔMICA:
Renda familiar per capita: R$ [VALOR]
Composição familiar: [PESSOAS NA FAMÍLIA]

ESTADO DE SAÚDE:
[CONDIÇÕES DE SAÚDE, SE RELEVANTES]

DOCUMENTOS ANEXOS:
- Cadastro Único (CadÚnico)
- Comprovantes de renda familiar
- Documentos pessoais

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-aposentadoria-invalidez',
          name: 'Requerimento de aposentadoria por invalidez',
          type: 'Aposentadoria por Invalidez',
          description: 'Aposentadoria por incapacidade permanente',
          icon: 'UserX',
          content: `REQUERIMENTO DE APOSENTADORIA POR INVALIDEZ

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer aposentadoria por invalidez.

MOTIVO DA INCAPACIDADE:
[DESCRIÇÃO DA DOENÇA/CONDIÇÃO]

INÍCIO DA INCAPACIDADE: [DATA]

PROGNÓSTICO: Incapacidade total e definitiva

DOCUMENTOS MÉDICOS:
- Laudos especializados
- Exames complementares
- Relatórios de tratamento

TEMPO DE CONTRIBUIÇÃO: [ANOS] anos

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-auxilio-suplementar',
          name: 'Requerimento de auxílio suplementar',
          type: 'Auxílio Suplementar',
          description: 'Auxílio para segurado com necessidade especial',
          icon: 'Plus',
          content: `REQUERIMENTO DE AUXÍLIO SUPLEMENTAR

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer auxílio suplementar.

NECESSIDADE ESPECIAL:
[DESCRIÇÃO DA NECESSIDADE]

BENEFÍCIO ATUAL:
Tipo: [TIPO DE BENEFÍCIO]
Número: [NB]
Valor: R$ [VALOR]

FUNDAMENTAÇÃO:
[BASE LEGAL PARA O AUXÍLIO]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'requerimento-reabilitacao-profissional',
          name: 'Requerimento de reabilitação profissional',
          type: 'Reabilitação',
          description: 'Solicitação de reabilitação para retorno ao trabalho',
          icon: 'RefreshCw',
          content: `REQUERIMENTO DE REABILITAÇÃO PROFISSIONAL

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer reabilitação profissional.

SITUAÇÃO ATUAL:
Benefício: [TIPO DE BENEFÍCIO]
Limitações: [DESCRIÇÃO DAS LIMITAÇÕES]

OBJETIVO:
( ) Retorno à função anterior
( ) Adaptação para nova função
( ) Capacitação profissional

POTENCIAL DE REABILITAÇÃO:
[AVALIAÇÃO MÉDICA/SOCIAL]

DOCUMENTOS ANEXOS:
- Relatórios médicos
- Avaliação funcional
- Histórico profissional

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        }
      ]
    },
    {
      id: 'outros-previdenciarios',
      name: 'Outros Documentos',
      emoji: '📄',
      templates: [
        {
          id: 'declaracao-dependente',
          name: 'Declaração de dependente econômico',
          type: 'Declaração',
          description: 'Declaração de dependência econômica',
          icon: 'FileText',
          content: `DECLARAÇÃO DE DEPENDENTE ECONÔMICO

Eu, [NOME DO DECLARANTE], [QUALIFICAÇÃO], DECLARO, sob as penas da lei, que [NOME DO DEPENDENTE] é meu dependente econômico, sustentado exclusivamente por mim.

DADOS DO DEPENDENTE:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- Data de Nascimento: [DATA]
- Grau de Parentesco: [PARENTESCO]

RENDA MENSAL DO DECLARANTE: R$ [VALOR]
DESPESAS COM O DEPENDENTE: R$ [VALOR]

Por ser verdade, firmo a presente.

[LOCAL], [DATA]

_________________________________
[NOME DO DECLARANTE]`
        },
        {
          id: 'declaracao-vida',
          name: 'Declaração de vida e residência',
          type: 'Declaração',
          description: 'Declaração para manutenção de benefício',
          icon: 'FileText',
          content: `DECLARAÇÃO DE VIDA E RESIDÊNCIA

Eu, [NOME COMPLETO], [QUALIFICAÇÃO], beneficiário(a) do [TIPO DE BENEFÍCIO] nº [NÚMERO], DECLARO:

1. Que estou vivo(a) e em pleno gozo de minhas faculdades mentais;
2. Que resido no endereço: [ENDEREÇO COMPLETO];
3. Que não houve alteração em minha situação que possa afetar o benefício.

Por ser verdade, firmo a presente declaração.

[LOCAL], [DATA]

_________________________________
[NOME DO BENEFICIÁRIO]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'procuracao-inss',
          name: 'Procuração específica para INSS',
          type: 'Procuração',
          description: 'Procuração para representação no INSS',
          icon: 'FileText',
          content: `PROCURAÇÃO AD JUDICIA ET EXTRA

OUTORGANTE: [NOME], [QUALIFICAÇÃO]
OUTORGADO: [NOME DO ADVOGADO], [QUALIFICAÇÃO]

O OUTORGANTE nomeia e constitui como seu procurador o OUTORGADO para representá-lo perante o INSS, com poderes para:

- Requerer benefícios previdenciários;
- Interpor recursos administrativos;
- Receber valores e documentos;
- Acompanhar processos administrativos;
- Praticar todos os atos necessários.

Esta procuração é válida até [DATA] ou revogação expressa.

[LOCAL], [DATA]

_________________________________
[NOME DO OUTORGANTE]

ACEITE:
_________________________________
[NOME DO ADVOGADO]
OAB/[ESTADO] [NÚMERO]`
        },
        {
          id: 'justificacao-administrativa',
          name: 'Pedido de justificação administrativa',
          type: 'Justificação',
          description: 'Comprovação de tempo de contribuição',
          icon: 'FileText',
          content: `PEDIDO DE JUSTIFICAÇÃO ADMINISTRATIVA

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem solicitar JUSTIFICAÇÃO ADMINISTRATIVA para comprovação de tempo de contribuição.

PERÍODO A SER COMPROVADO:
De [DATA] a [DATA]

EMPRESA/EMPREGADOR:
[NOME DA EMPRESA]
CNPJ: [CNPJ]

FUNÇÃO EXERCIDA: [CARGO]

MOTIVO DA JUSTIFICAÇÃO:
[EXPLICAR POR QUE NÃO HÁ DOCUMENTAÇÃO]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'declaracao-atividade-rural',
          name: 'Declaração de atividade rural',
          type: 'Declaração Rural',
          description: 'Comprovação de trabalho rural',
          icon: 'Wheat',
          content: `DECLARAÇÃO DE ATIVIDADE RURAL

O Sindicato dos Trabalhadores Rurais de [MUNICÍPIO], DECLARA que [NOME DO TRABALHADOR], [QUALIFICAÇÃO], exerceu atividade rural neste município.

PERÍODO: [DATA INÍCIO] a [DATA FIM]

ATIVIDADE: [TIPO DE ATIVIDADE RURAL]

PROPRIEDADE: [IDENTIFICAÇÃO DA PROPRIEDADE]

REGIME DE TRABALHO:
( ) Economia familiar
( ) Parceiro/meeiro
( ) Arrendatário
( ) Assalariado rural

Por ser verdade, expedimos a presente declaração.

[LOCAL], [DATA]

_________________________________
[NOME DO PRESIDENTE]
Presidente do Sindicato Rural`
        },
        {
          id: 'declaracao-nao-exercicio',
          name: 'Declaração de não exercício de atividade',
          type: 'Declaração',
          description: 'Declaração de inatividade profissional',
          icon: 'XCircle',
          content: `DECLARAÇÃO DE NÃO EXERCÍCIO DE ATIVIDADE

Eu, [NOME COMPLETO], [QUALIFICAÇÃO], DECLARO, sob as penas da lei, que:

1. Não exerço atividade remunerada desde [DATA];
2. Não possuo renda própria;
3. Não contribuo para a Previdência Social;
4. Sou sustentado(a) por [NOME DO RESPONSÁVEL].

MOTIVO DA INATIVIDADE:
[RAZÃO DA NÃO ATIVIDADE]

Por ser verdade, firmo a presente declaração.

[LOCAL], [DATA]

_________________________________
[NOME DO DECLARANTE]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]
2. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'termo-responsabilidade-pensao',
          name: 'Termo de responsabilidade - pensão',
          type: 'Termo',
          description: 'Termo para recebimento de pensão em nome de menor',
          icon: 'Shield',
          content: `TERMO DE RESPONSABILIDADE

Eu, [NOME DO RESPONSÁVEL], [QUALIFICAÇÃO], na qualidade de [GRAU DE PARENTESCO] de [NOME DO MENOR], assumo a responsabilidade pelo recebimento da pensão por morte nº [NÚMERO DO BENEFÍCIO].

DADOS DO MENOR:
- Nome: [NOME COMPLETO]
- Data de nascimento: [DATA]
- CPF: [CPF]

COMPROMISSOS:
1. Utilizar o benefício exclusivamente em favor do menor;
2. Informar ao INSS qualquer alteração na situação;
3. Apresentar comprovante de vida anualmente;
4. Devolver valores recebidos indevidamente.

[LOCAL], [DATA]

_________________________________
[NOME DO RESPONSÁVEL]

TESTEMUNHAS:
1. [NOME], [QUALIFICAÇÃO]  
2. [NOME], [QUALIFICAÇÃO]`
        },
        {
          id: 'comunicacao-obito',
          name: 'Comunicação de óbito ao INSS',
          type: 'Comunicação',
          description: 'Comunicação de falecimento de beneficiário',
          icon: 'AlertTriangle',
          content: `COMUNICAÇÃO DE ÓBITO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO COMUNICANTE], [QUALIFICAÇÃO], vem comunicar o falecimento de [NOME DO FALECIDO], beneficiário da Previdência Social.

DADOS DO FALECIDO:
- Nome: [NOME COMPLETO]
- CPF: [CPF]
- Número do benefício: [NB]
- Data do óbito: [DATA]
- Local: [LOCAL DO ÓBITO]

GRAU DE PARENTESCO: [PARENTESCO]

DOCUMENTOS ANEXOS:
- Certidão de óbito
- Documento de identidade do comunicante

Solicito as providências cabíveis.

[LOCAL], [DATA]

_________________________________
[NOME DO COMUNICANTE]`
        },
        {
          id: 'requerimento-certidao-tempo-contribuicao',
          name: 'Requerimento de certidão de tempo de contribuição',
          type: 'Certidão',
          description: 'Solicitação de certidão para contagem de tempo',
          icon: 'FileCheck',
          content: `REQUERIMENTO DE CERTIDÃO DE TEMPO DE CONTRIBUIÇÃO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem requerer CERTIDÃO DE TEMPO DE CONTRIBUIÇÃO para fins de:

FINALIDADE:
( ) Contagem recíproca
( ) Averbação em regime próprio
( ) Comprovação para terceiros
( ) Outro: [ESPECIFICAR]

PERÍODO SOLICITADO:
De [DATA INÍCIO] a [DATA FIM]

DADOS ADICIONAIS:
- Empresas: [RELAÇÃO]
- Atividades: [DESCRIÇÃO]

DOCUMENTOS ANEXOS:
[LISTA DE DOCUMENTOS]

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'pedido-unificacao-cadastro',
          name: 'Pedido de unificação de cadastro',
          type: 'Unificação',
          description: 'Solicitação para unificar cadastros duplicados',
          icon: 'Merge',
          content: `PEDIDO DE UNIFICAÇÃO DE CADASTRO

Ao INSS - Instituto Nacional do Seguro Social

[NOME DO REQUERENTE], [QUALIFICAÇÃO], vem solicitar a UNIFICAÇÃO dos seguintes cadastros:

CADASTRO PRINCIPAL (a manter):
- NIT/PIS: [NÚMERO]
- CPF: [CPF]

CADASTROS A UNIFICAR:
- NIT/PIS: [NÚMERO]
- NIT/PIS: [NÚMERO]

MOTIVO DA DUPLICIDADE:
[EXPLICAR COMO OCORREU]

DOCUMENTOS ANEXOS:
- Documento de identidade
- CPF
- Comprovantes dos vínculos

Nestes termos, pede deferimento.

[LOCAL], [DATA]

_________________________________
[NOME DO REQUERENTE]`
        },
        {
          id: 'declaracao-tempo-servico-publico',
          name: 'Declaração de tempo de serviço público',
          type: 'Declaração',
          description: 'Comprovação de tempo no serviço público',
          icon: 'Building',
          content: `DECLARAÇÃO DE TEMPO DE SERVIÇO PÚBLICO

O [ÓRGÃO PÚBLICO], por meio do setor de recursos humanos, DECLARA que [NOME DO SERVIDOR], [QUALIFICAÇÃO], exerceu cargo público neste órgão:

DADOS DO SERVIDOR:
- Matrícula: [NÚMERO]
- Cargo: [DENOMINAÇÃO]
- Período: [DATA INÍCIO] a [DATA FIM]
- Tempo total: [ANOS, MESES, DIAS]

CONTRIBUIÇÕES PREVIDENCIÁRIAS:
( ) Recolhidas ao RGPS
( ) Recolhidas ao RPPS
( ) Não recolhidas

Por ser verdade, expedimos a presente.

[LOCAL], [DATA]

_________________________________
[NOME DO RESPONSÁVEL]
[CARGO/FUNÇÃO]`
        }
      ]
    }
  ]
};
